var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHand4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M10.973 14.953 10.975 12m0 0c-.001-.926.672-1.638 1.502-1.639.831 0 1.505.712 1.505 1.639l.002 1m-3.01-1 .018-5.101c0-.927-.673-1.679-1.504-1.679h-.002c-.83.001-1.502.753-1.501 1.679.007 6.556.006 9.113-.002 9.111-1.378 0-2.421-1.953-4.23-1.953-1.81 0-2.113 1.073-1.39 2.023.482.633 5.62 6.92 5.62 6.92H16a4 4 0 0 0 4-4v-4.82c0-.927-.674-1.679-1.505-1.679h-.001c-.83.001-1.502.753-1.501 1.679M13.983 13v1.953m0-1.953c0-.926.672-1.678 1.502-1.679h.001c.831 0 1.505.752 1.505 1.679l.002 1.179m0 0-.002.774M14.416 6.25h-1.5m-7 0H4.12m9.009-3.712L11.89 3.775M5.704 2.538l1.238 1.237M9.416 1v1.75"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHand4);
export default __webpack_public_path__ + "static/media/hand4.61e37184e614f0d7ea52094ae145606e.svg";
export { ForwardRef as ReactComponent };